<template>
  <a v-if="smooth" @click="handleClick" class="cta" v-smooth-scroll :href=href >{{ text }}</a>
  <a v-else class="cta" @click="handleClick" :href=href >{{ text }}</a>
</template>

<script>
export default {
  name: "cta",
  props: ["href", "text", "smooth"],
  methods: {
    handleClick() {
      this.$emit("ctaClicked");
    }
  }
}
</script>

<style lang="scss" scoped>
  .cta {
    @include noselect;
    display: inline-block;
    padding: 1em 1.5em;
    border-radius: 100px;
    font-size: 16px;
    text-align: center;
    text-decoration: none;
    color: $color-black;
    background-color: $color-grey;
    cursor: pointer;
    transition: background-color 0.05s ease-in-out, color 0.05s ease-in-out;

    &:hover, &:active, &:focus {
      background-color: $color-red;
      color: $color-white;
    }
  }
</style>
